import { Store } from 'vuex';
import { TOptions } from '@/plugins/podolib/services/acl';
import { default as _Vue } from 'vue';
import { EventEmitter } from 'events';
import consola, { Consola } from 'consola';

export abstract class AbstractEventEmitterService extends EventEmitter {
  protected Vue!: typeof _Vue;
  protected store!: Store<any>;
  protected logger: Consola;
  protected options: any;

  public serviceName: string;

  protected constructor(options: TOptions, serviceName: string) {
    super();
    this.options = options;
    this.serviceName = serviceName;

    this.logger = consola.withTag(serviceName);
  }

  async init(Vue: typeof _Vue, store: Store<any>): Promise<void> {
    this.Vue = Vue;
    this.store = store;

    this.printNameInConsole();
  }

  public printNameInConsole() {
    this.logger.log('📦 Loaded as emitter service');
  }

  emitDebug(event: string, ...args: any) {
    super.emit(event, ...args);
    // this.logger.log('EMIT', event, args);
  }
}
